import {createSlice} from "@reduxjs/toolkit";

const initialHelpDeskState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  helpdeskForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const helpdeskSlice = createSlice({
  name: "helpdesk",
  initialState: initialHelpDeskState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getHelpDeskById
    helpdeskFetched: (state, action) => {
      state.actionsLoading = false;
      state.helpdeskForEdit = action.payload.helpdeskForEdit;
      state.error = null;
    },
    // findHelpDesk
    helpdesksFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createHelpDesk
    helpdeskCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.helpdesk);
    },
    // updateHelpDesk
    helpdeskUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.helpdesk.id) {
          return action.payload.helpdesk;
        }
        return entity;
      });
    },
    // deleteHelpDesk
    helpdeskDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteHelpDesk
    helpdesksDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // helpdeskUpdateState
    helpdeskStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    },
    // fetchMyHelpDesk
    myHelpDeskFetched: (state, action) => {
      const { totalCount, entities, individual_applications } = action.payload;
      state.listLoading = false;
      state.actionsLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.individualApplications = individual_applications;
    },
  }
});
